import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class videoGallery extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />

                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                NEWS &amp; PR
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Video Gallary
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    <section className="Shuttle_Bus_Service_section">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Gallary</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                Video Gallary
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40" data-aos="fade-up" data-aos-delay={700}>
                                <div className="col-md-12">
                                    <div className="Gallery_section">
                                        <div className="row gutter-24 project-active-two">
                                            <div className="col-lg-3 col-md-6 grid-item grid-sizer">
                                                <div className="galllary_img_div">
                                                    <div className="project__item-two video_gallary">
                                                        <div className="project__thumb-two">
                                                            <img src="assets/img/Gallary/video_1.jpg" alt="img" />
                                                            <p>India ITME</p>
                                                        </div>
                                                    </div>
                                                    <a
                                                        href="https://www.youtube.com/embed/BBT7Ypf7wMk"
                                                        data-gallery="portfolioGallery"
                                                        className="portfolio-lightbox"
                                                        target="_blank"
                                                    >
                                                        <i className="fas fa-video" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6 grid-item grid-sizer">
                                                <div className="galllary_img_div">
                                                    <div className="project__item-two video_gallary">
                                                        <div className="project__thumb-two">
                                                            <img src="assets/img/Gallary/video_2.jpg" alt="img" />
                                                            <p>GTTES</p>
                                                        </div>
                                                    </div>
                                                    <a
                                                        href="https://www.youtube.com/embed/OYyZECjrz7w"
                                                        data-gallery="portfolioGallery"
                                                        className="portfolio-lightbox"
                                                        target="_blank"
                                                    >
                                                        <i className="fas fa-video" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6 grid-item grid-sizer">
                                                <div className="galllary_img_div">
                                                    <div className="project__item-two video_gallary">
                                                        <div className="project__thumb-two">
                                                            <img src="assets/img/Gallary/video_3.jpg" alt="img" />
                                                            <p>India ITME Society</p>
                                                        </div>
                                                    </div>
                                                    <a
                                                        href="https://www.youtube.com/embed/h3vbPxz6Wzc"
                                                        data-gallery="portfolioGallery"
                                                        className="portfolio-lightbox"
                                                        target="_blank"
                                                    >
                                                        <i className="fas fa-video" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6 grid-item grid-sizer">
                                                <div className="galllary_img_div">
                                                    <div className="project__item-two video_gallary">
                                                        <div className="project__thumb-two">
                                                            <img src="assets/img/Gallary/video_4.jpg" alt="img" />
                                                            <p>ITME Africa</p>
                                                        </div>
                                                    </div>
                                                    <a
                                                        href="https://www.youtube.com/embed/fib47zeouf8"
                                                        data-gallery="portfolioGallery"
                                                        className="portfolio-lightbox"
                                                        target="_blank"
                                                    >
                                                        <i className="fas fa-video" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>


                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(videoGallery));